enum ProjectFormFieldMaxLengths {
  ProjectName = 100,
  AzdoAlias = 256,
  ProjectCode = 5
}

export default ProjectFormFieldMaxLengths;
